import styled from "styled-components";

export const FilterContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 7px 0;
`;

export const SearchDiv = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 5px;
`;

export const ActionLeft = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: auto;
`;

export const FilterStyled = styled.div`
    width: 100%;
`;

export const DateFilter = styled.div`
    width: 100%;
    display: flex;
    gap: 0 7px;

    > div {
        width: 100%;
        > div {
            margin: 0;
        }
    }
`;

export const SearchContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 10px;
    min-width: 320px;

    div {
        display: flex;
        gap: 5px;
    }
`;
